export default __webpack_public_path__ + "static/media/Leggings of the Rippling Lake.814cd079.jpg";